import React, { useState, useEffect, useCallback } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { ActiveCell, EditCommandCell } from "../GridComponents";
import { getLookups, updateLookup } from "api/accountsAPI";
import EditClientDocumentType from "./EditClientDocumentType";
import { GridLoader } from "components/GridLoader";
import styles from "../Settings.module.scss";

const ClientDocumentTypesList = ({ refreshKey }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchItems = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getLookups("ClientDocumentTypes");
      setItems(res?.data?.data ?? []);
    } catch (_) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchItems();
  }, [fetchItems, refreshKey]);

  const enterEdit = (item) => {
    setEditItem(item);
    setOpenForm(true);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      await updateLookup("ClientDocumentTypes", event.lookupID, {
        value: event.value,
        active: event.active,
      });
      setOpenForm(false);
      await fetchItems();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={`settings-grid h-100 ${styles.settingsGrid}`}>
      <Grid
        data={items}
        style={{ height: "100%" }}
        showLoader={loading}
        loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }
      >
        <GridNoRecords>
          {loading ? <span></span> : items.length === 0 && "No records available"}
        </GridNoRecords>
        <Column field="value" title="Name" />
        <Column cell={ActiveCell} title="Active" field="active" width="80px" />
        <Column
          title="Edit"
          cell={(props) => <EditCommandCell {...props} enterEdit={enterEdit} />}
          width="60px"
        />
      </Grid>

      {openForm && (
        <EditClientDocumentType
          item={editItem}
          isSubmitting={isSubmitting}
          onSubmit={handleSubmit}
          cancelEdit={() => setOpenForm(false)}
        />
      )}
    </div>
  );
};

export default ClientDocumentTypesList;
